import { COMPILED_COLLISION_CELLS_PER_TILE, resolveMap, type CompileContext, type MapDocument, type WorldDocument } from "daedalus-core";
import { SOLID } from "../collision/flags.ts";
import type { CollisionGrid } from "../movement/step.ts";
import { ODYSSEY_ADAPTER } from "./adapter.ts";
import { stampBlockingThings } from "./thing-blocks.ts";

/**
 * The collision grid a published chunk carries for one map: terrain, plain props and collision layers, with the cells
 * every thing blocks whatever a player does marked over it (`stampBlockingThings`), so a check run where a document is
 * compiled sees the ground as a character stands on it.
 *
 * @param world The document.
 * @param map One of its maps.
 * @param context The compile context.
 * @returns The grid, at the compiled collision cell.
 * @throws Error when the map does not resolve, as `resolveMap` throws, or a thing's state cannot be laid, as
 *   `stampBlockingThings` throws.
 */
export function compiledGridOf(world: WorldDocument, map: MapDocument, context: CompileContext): CollisionGrid {
  const cells = Uint8Array.from(resolveMap(world, map, context).collision);
  stampBlockingThings(cells, map, context, ODYSSEY_ADAPTER.objectTypes ?? [], world.tileSize, SOLID);
  return { width: map.width * COMPILED_COLLISION_CELLS_PER_TILE, height: map.height * COMPILED_COLLISION_CELLS_PER_TILE, cells, outside: context.collision.outside };
}
